import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { isDemoSite } from "../demoSite";

function DemoChooser({onClose}: {onClose: () => void}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => { const dialog = ref.current; dialog?.showModal(); return () => dialog?.close(); }, []);
  return <dialog ref={ref} className="demo-chooser" aria-labelledby="demo-chooser-title" onCancel={onClose} onClick={event => {if (event.target === event.currentTarget) onClose();}}>
    <div className="demo-chooser-body"><header><div><h2 id="demo-chooser-title">选择演示</h2><p>无需登录，体验示例数据。</p></div><button autoFocus type="button" aria-label="关闭演示选择" onClick={onClose}>关闭</button></header>
    <div className="demo-chooser-options"><Link to="/student-demo" onClick={onClose}><span>学生demo</span><p>查看动作评分、数据曲线和 AI 训练评价</p><strong>查看学生结果 →</strong></Link><Link to="/teacher-demo" onClick={onClose}><span>教师demo</span><p>查看班级表现、学生档案和教学数据</p><strong>查看教师看板 →</strong></Link></div>
    </div>
  </dialog>;
}
export function DemoEntry({className = "", onOpen}: {className?: string; onOpen?: () => void}) {
  const [open, setOpen] = useState(false);
  if (!isDemoSite) return null;
  return <><button className={`demo-entry ${className}`} type="button" aria-haspopup="dialog" onClick={() => {setOpen(true); onOpen?.();}}>演示demo</button>{open ? createPortal(<DemoChooser onClose={() => setOpen(false)} />, document.body) : null}</>;
}
